import { ActionIcon, Group, Icon, Loader, Modal, Text } from '@inflearn/ds-react-next';
import { useLang } from '@inflearn/i18n-tools';
import { faCircleInfo } from '@inflearn/pro-regular-svg-icons';
import { useDisclosure } from '@mantine/hooks';
import { useTranslation } from 'next-i18next';

import { REVIEW_POLICY_GUIDE_ID } from '../../constants/reviewPolicyGuide';
import useGuidesIdQuery from '../../queries/useGuidesIdQuery';
import { GeneratedHtml } from './GeneratedHtml';

/**
 * 수강평 섹션 타이틀 옆의 info 아이콘. 클릭하면 어드민 안내글의 "수강평 운영정책"
 * (작성 가능 범위·게시 기간·등급평가 기준·삭제 기준·이의제기 절차)을 모달로 보여준다.
 */
export const ReviewPolicyGuideButton = () => {
  const { t } = useTranslation();
  const { lang } = useLang();
  const [opened, { open, close }] = useDisclosure(false);
  const { data, isLoading, isError } = useGuidesIdQuery(REVIEW_POLICY_GUIDE_ID[lang], {
    enabled: opened,
    staleTime: Number.POSITIVE_INFINITY,
  });

  return (
    <>
      <ActionIcon
        variant="subtle"
        color="gray"
        // 토큰 사이즈(n-xs)는 자식 Icon 을 12px 로 덮어쓰므로, 14px 아이콘을 쓰기 위해 숫자 사이즈로 지정
        size={30}
        radius="xl"
        aria-label={t('review_policy_guide.button.aria_label')}
        onClick={open}
      >
        <Icon icon={faCircleInfo} size={14} color="gray.6" />
      </ActionIcon>
      <Modal.Root opened={opened} onClose={close} size="lg">
        <Modal.Overlay />
        <Modal.Content>
          <Modal.Header>
            <Modal.Title>{data?.title ?? t('review_policy_guide.modal.title')}</Modal.Title>
            <Modal.CloseButton />
          </Modal.Header>
          <Modal.Body>
            {isLoading ? (
              <Group justify="center" py={40}>
                <Loader size="sm" />
              </Group>
            ) : null}
            {isError ? (
              <Text size="sm" c="gray.6">
                {t('review_policy_guide.modal.load_error')}
              </Text>
            ) : null}
            {data ? <GeneratedHtml html={data.body} /> : null}
          </Modal.Body>
        </Modal.Content>
      </Modal.Root>
    </>
  );
};
